import Swal from "sweetalert2";
import { Utils } from "./utils.js";
import { Api } from "../api/api.js";
import store from '../../store/index'
import { EventBus } from './../../frontend/event-bus.js'
import { i18n } from '@/plugins/i18n'
import CustomerForm from './../views/CustomerForm.vue'

export const NotificationUtil = {
  /**
   * Checks if the text is a valid email format
   */
  isEmail: (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  },
  /**
   * Show cancel scheduled email notification
   * @param {*} order
   * @param {*} cb
   */
  showCancelEmailPopup: async (order, userId, cb) => {
    //console.log("showCancelEmailPopup", order);
    const swalAlertResult = await Swal.fire({
      title: "Warning",
      html: `<p>There is already a scheduled email to be sent to <span style="color:red">${
        order.scheduledNotification.email
      }</span> on 
          <span style="color:red">${Utils.getDateDisplayInLocalTime(
            order.scheduledNotification.scheduledAt
          )}</span></p>`,
      showCancelButton: true,
      confirmButtonText: "Cancel Email",
      cancelButtonText: "Dismiss",
    });

    if (
      swalAlertResult.dismiss == "cancel" ||
      swalAlertResult.dismiss == "backdrop"
    ) {
      //do nothing
      cb(false);

      return;
    } else if (swalAlertResult.isConfirmed) {
      //cancel the scheduledEmail
      const cancelResult = await Api.cancelScheduledEmailNotification(
        order.scheduledNotification._id || order.scheduledNotification.id,
        userId
      );
      if (cancelResult) {
        return cb(true);
      }
      return cb(false);
    }
  },

  emailExists: (email) => {
    const subscribers = store.state.backConfig.subscriber || [];
    
    return subscribers.some(subscriber => subscriber.Email === email || subscriber.EmailAddress === email);
  },

  emailCustomerExist: (email) => {
    const customers = store.state.backConfig.allCustomer || [];
    
    return customers.some(customer => customer.Email === email || customer.EmailAddress === email)
  },

  toggleSelectAll: function(type) {
    const checkboxes = document.querySelectorAll(`.${type}-checkbox`);
    const selectAllCheckbox = document.getElementById(`select-all-${type}s`);
  
    checkboxes.forEach(checkbox => {
      checkbox.checked = selectAllCheckbox.checked;
    });
  },

  bulkSendEmail: async (toEmail, toPhone, scheduledAt, cb, emailLabel = null, showButtons) => {
    const customers = store.state.backConfig.allCustomer || [];
    const subscribers = store.state.backConfig.subscriber || [];
    
    const filterByMethod = (items, emailChecked, smsChecked) => {
      return items.filter(item => {
        const hasEmail = item.Email || item.EmailAddress;
        const hasPhone = item.Phone;
        
        if (emailChecked && smsChecked) {
          return true; 
        } else if (emailChecked) {
          return hasEmail; 
        } else if (smsChecked) {
          return hasPhone; 
        }
        return false;
      });
    };

    let emailChecked = true;
    let smsChecked = true;
    let filteredCustomers = customers;
    let filteredSubscribers = subscribers;
    
    const now = scheduledAt || new Date();
    const dateTimeString = now.toISOString().slice(0, 16);
    
    const generateListHtml = (items, prefix) => {
      return items.map((item) => {
        const itemJson = JSON.stringify(item)
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#39;');
        
        return `
        <ul style="list-style: none; padding: 0; margin: 0;">
          <li style="display: flex; justify-content: space-between; align-items: center; padding: 12px 0; border-bottom: 1px solid #ccc;">
            <div style="display: flex; align-items: center; gap: 8px;">
              <input type="checkbox" class="${prefix}-checkbox" id="${prefix}-${item._id}" value="${item.Email || item.EmailAddress}">
              <label for="${prefix}-${item._id}">
                ${item.Name} (${item.Email || item.EmailAddress || ''}, ${item.Phone || ''})
              </label>
            </div>
            <a href="#" onclick="window.open${prefix.charAt(0).toUpperCase() + prefix.slice(1)}Modal('${itemJson}')" style="text-decoration: none;">
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 24 24">
                  <path fill="currentColor" d="M18.58 2.944a2 2 0 0 0-2.828 0L14.107 4.59l5.303 5.303l1.645-1.644a2 2 0 0 0 0-2.829zm-.584 8.363l-5.303-5.303l-8.835 8.835l-1.076 6.38l6.38-1.077z"/>
                </svg>
              </span>
            </a>
          </li>
        </ul>`;
      }).join('');
    };

    const updateLists = () => {
      emailChecked = document.getElementById('email-checkbox').checked;
      smsChecked = document.getElementById('sms-checkbox').checked;
      
      filteredCustomers = filterByMethod(customers, emailChecked, smsChecked);
      filteredSubscribers = filterByMethod(subscribers, emailChecked, smsChecked);
      
      document.querySelector('.customer-list-container').innerHTML = 
        generateListHtml(filteredCustomers, 'customer', customers);
      document.querySelector('.subscriber-list-container').innerHTML = 
        generateListHtml(filteredSubscribers, 'subscriber', subscribers);
      
      assignCheckboxEvents();
    };

    const assignCheckboxEvents = () => {
      document.getElementById('select-all-customers').addEventListener('change', function() {
        const checkboxes = document.querySelectorAll('.customer-checkbox');
        checkboxes.forEach(checkbox => {
          checkbox.checked = this.checked;
        });
      });
      
      document.getElementById('select-all-subscribers').addEventListener('change', function() {
        const checkboxes = document.querySelectorAll('.subscriber-checkbox');
        checkboxes.forEach(checkbox => {
          checkbox.checked = this.checked;
        });
      });
    };

    const { value: selectedRecipients } = await Swal.fire({
      title: i18n.t('backoffice.bulkSend.selectRecipientsTitle'),
      width: '800px',
      html: `
      <style>
        .recipient-container {
          display: flex;
          gap: 20px;
          max-height: 300px;
          overflow-y: auto;
          border: 1px solid black;
          border-radius: 6px;
          padding: 10px;
          font-size:15px
        }

        .recipient-column {
          flex: 1;
          min-width: 200px;
        }

        .list-container {
          max-height: 400px;
        }

        .message-container {
          margin: 20px 0;
        }

        .message-input {
          width: 100%;
          min-height: 100px;
          padding: 10px;
          border: 1px solid #ddd;
          border-radius: 4px;
          resize: vertical;
        }

        @media (max-width: 600px) {
          .recipient-container {
            flex-direction: column;
          }

          .recipient-column {
            width: 100%;
            min-width: auto;
          }
          .info-label{
            color: #2d6ce1;
            font-size:13px;
          }
        }
      </style>
      <div>
        <label style="color: #2d6ce1;font-size:13px; text-align: left;">If the customer or subscriber does not have an email or a phone number they will not appear in the list when either Bulk Email or Bulk SMS is chosen.</label>
      </div>
        <div>
          <label><input type="checkbox" id="email-checkbox" checked> ${i18n.t('backoffice.bulkSend.sendEmail')}</label>
          <label><input type="checkbox" id="sms-checkbox" checked> ${i18n.t('backoffice.bulkSend.sendSMS')}</label><br>
        </div>
        <div style="margin-bottom: 10px;">
          <input type="text" id="recipient-search" placeholder="${i18n.t('frontend.home.search')}" style="width: 100%; padding: 8px; border-radius:12px;" />
        </div>
        <div style="text-align: left;" class="recipient-container">
          <div class="recipient-column">
            <h3>Customers</h3>
            <input type="checkbox" id="select-all-customers">
            <label for="select-all-customers">${i18n.t('backoffice.bulkSend.selectAllCustomers')}</label>
            <div class="list-container customer-list-container">
              ${generateListHtml(filteredCustomers, 'customer', customers)}
            </div>
          </div>
          <div class="recipient-column">
            <h3>Subscribers</h3>
            <input type="checkbox" id="select-all-subscribers">
            <label for="select-all-subscribers">${i18n.t('backoffice.bulkSend.selectAllSubscribers')}</label>
            <div class="list-container subscriber-list-container">
              ${generateListHtml(filteredSubscribers, 'subscriber', subscribers)}
            </div>
          </div>
        </div>`,
      didOpen: () => {
        document.getElementById('email-checkbox').addEventListener('change', updateLists);
        document.getElementById('sms-checkbox').addEventListener('change', updateLists);
        
        assignCheckboxEvents();
        
        window.openCustomerModal = (customerData) => {
          try {
            const customer = typeof customerData === 'string' 
              ? JSON.parse(customerData.replace(/&quot;/g, '"').replace(/&#39;/g, "'")) 
              : customerData;
            
            if (customer && customer._id) {
              Swal.close();
              EventBus.$emit('open-customer-modal', customer._id);
            }
          } catch (e) {
            console.error("Error processing customer data:", e, customerData);
          }
        };
        
        window.openSubscriberModal = (subscriberData) => {
          try {
            const subscriber = typeof subscriberData === 'string'
              ? JSON.parse(subscriberData.replace(/&quot;/g, '"').replace(/&#39;/g, "'"))
              : subscriberData;
            
            if (subscriber && subscriber._id) {
              Swal.close();
              EventBus.$emit('open-subscriber-modal', subscriber._id);
            }
          } catch (e) {
            console.error("Error processing subscriber data:", e, subscriberData);
          }
        };
        
        // Búsqueda
        const searchInput = document.getElementById('recipient-search');
        searchInput.addEventListener('input', () => {
          const term = searchInput.value.toLowerCase();
          
          // Buscar en clientes
          document.querySelectorAll('.customer-checkbox').forEach(cb => {
            const li = cb.closest('li');
            const label = cb.nextElementSibling;
            const text = label?.textContent?.toLowerCase() || '';
            li.style.display = text.includes(term) ? 'flex' : 'none';
          });
          
          // Buscar en suscriptores
          document.querySelectorAll('.subscriber-checkbox').forEach(cb => {
            const li = cb.closest('li');
            const label = cb.nextElementSibling;
            const text = label?.textContent?.toLowerCase() || '';
            li.style.display = text.includes(term) ? 'flex' : 'none';
          });
        });
      },
      focusConfirm: false,
      preConfirm: () => {
        const selected = [];
        
        // Obtener seleccionados de clientes
        document.querySelectorAll('.customer-checkbox:checked').forEach(checkbox => {
          // const id = checkbox.id.split('-')[1];
          // const item = customers[id];
          const id = checkbox.id.split('-')[1];
          const item = customers.find(c => c._id === id);

          if (item) {
            selected.push({ 
              email: item.Email || item.EmailAddress, 
              phone: item.Phone 
            });
          }
        });
        
        // Obtener seleccionados de suscriptores
        document.querySelectorAll('.subscriber-checkbox:checked').forEach(checkbox => {
          // const id = checkbox.id.split('-')[1];
          // const item = subscribers[id];
          const id = checkbox.id.split('-')[1];
const item = subscribers.find(s => s._id === id);

          if (item) {
            selected.push({ 
              email: item.Email || item.EmailAddress, 
              phone: item.Phone || item.phone
            });
          }
        });
        
        if (selected.length === 0) {
          Swal.showValidationMessage(i18n.t('backoffice.bulkSend.validationSelectRecipients'));
          return false;
        }
        
        return selected;
      }
    });

    // Resto del código (envío de notificaciones) permanece igual...
    if (!selectedRecipients) return;
    
    const emailCheckedFinal = document.getElementById("email-checkbox").checked;
    const smsCheckedFinal = document.getElementById("sms-checkbox").checked;
    
    const method = [];
    if (emailCheckedFinal) method.push("email");
    if (smsCheckedFinal) method.push("phone");
    
    if (method.length === 0) {
      Swal.fire('Error', i18n.t('backoffice.bulkSend.validationSelectMethod'), 'error');
      return;
    }
    
    const message = document.getElementById('message-input').value;
    
    const result = await Swal.fire({
      title: i18n.t('backoffice.bulkSend.bulkSendOptionsTitle'),
      html: `
      <label for="swal-input1">${i18n.t('backoffice.bulkSend.whenToSend')}</label>
      <input id="swal-input1" class="swal2-input" type="datetime-local" value="${dateTimeString}">
      <div style="margin-top: 15px;">
        <label for="message-preview">${i18n.t('backoffice.bulkSend.messagePreview')}:</label>
        <p id="message-preview" style="white-space: pre-wrap; background: #f5f5f5; padding: 10px; border-radius: 4px;">${message}</p>
      </div>`,
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: i18n.t('backoffice.bulkSend.sendNow'),
      denyButtonText: i18n.t('backoffice.bulkSend.schedule'),
      cancelButtonText: i18n.t('backoffice.bulkSend.cancel'),
      preDeny: () => {
        const scheduleVal = document.getElementById("swal-input1").value;
        if (!scheduleVal || new Date(scheduleVal) <= new Date()) {
          Swal.showValidationMessage(i18n.t('backoffice.bulkSend.validationScheduledTime'));
          return false;
        }
        return true;
      }
    });

    const emails = selectedRecipients.map(r => r.email).filter(Boolean);
    const phones = selectedRecipients.map(r => r.phone).filter(Boolean);
 
    const notificationData = {
      email: emails.join(','),
      mobile: phones.join(','),
      method: method.join(','),
      subject: 'Bulk Notification',
      body: message,
      userId: '123',
      scheduledAt: result.isDenied ? new Date(document.getElementById("swal-input1").value).getTime() : null,
    };
 
    try {
      if (result.isConfirmed) {
        notificationData.scheduledAt = null;
        cb(false, notificationData);
      } else if (result.isDenied) {
        cb(false, notificationData);
      } else {
        cb(true, null);
      }
    } catch (error) {
      const msg = error?.response?.data?.reason || error?.response?.data?.message || 'An error occurred.';
      Swal.fire('Error', msg, 'error');
      cb(true, null);
    }
},

  async bulkInfo(toEmail, toPhone, scheduledAt, cb, emailLabel = null, showButtons) {
    const result = await Swal.fire({
      title: i18n.t('backoffice.bulkSend.title'),
      text: i18n.t('backoffice.bulkSend.text'),
      icon: "info",
      confirmButtonText: i18n.t('backoffice.bulkSend.confirmButtonText'),
      didOpen: () => {
        // Reducir el tamaño del icono con JavaScript
        document.querySelector(".swal2-icon").style.width = "40px";
        document.querySelector(".swal2-icon").style.height = "40px";
        document.querySelector(".swal2-icon").style.fontSize = "10px";
      }
    });
  
    if (result.isConfirmed) {
      NotificationUtil.bulkSendEmail(toEmail, toPhone, scheduledAt, cb, emailLabel, showButtons);
    }
  },
  

  showNotificationPopup: async (toEmail, toPhone, scheduledAt, cb, emailLabel = null,showButtons) => {
    if (!emailLabel) {
      emailLabel = i18n.t('backoffice.titles.sendNotification');
    }

    // Get current date and time
    var now = scheduledAt || new Date();
    var year = now.getFullYear();
    var month = String(now.getMonth() + 1).padStart(2, "0");
    var day = String(now.getDate()).padStart(2, "0");
    var hours = String(now.getHours()).padStart(2, "0");
    var minutes = String(now.getMinutes()).padStart(2, "0");
    var dateTimeString = `${year}-${month}-${day}T${hours}:${minutes}`;

    const result = await Swal.fire({
      title: i18n.t('backoffice.titles.shareViaEmailAndSMS'),
      html: `
        <p>${i18n.t('backoffice.titles.textSend')}</p>
        <input id="customer-search" class="swal2-input" type="text" placeholder="${i18n.t('backoffice.titles.searchCustomer')}"><br>
        <p style="color:gray; list-style: none; text-align: start; margin-left: 60px;" id="customer-list"></p>
        <label for="swal-input2">${emailLabel}</label>
        <input id="swal-input2" class="swal2-input" type="email" value="${toEmail}" placeholder="${i18n.t('backoffice.titles.emailPlaceholder')}"><br>
        <div style="display: inline-flex; align-items: center; gap: 5px;">
          <a id="bulk-send" style="font-size:14px;color:#2d6ce1;" title="Este envío será enviado a múltiples contactos">${i18n.t('backoffice.bulkSend.bulkSend')}</a>
          <a id="bulk-info" style="position: relative; font-size:14px;color:#2d6ce1; cursor: pointer;">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
              <path fill="currentColor" d="M11 17h2v-6h-2zm1-8q.425 0 .713-.288T13 8t-.288-.712T12 7t-.712.288T11 8t.288.713T12 9m0 13q-2.075 0-3.9-.788t-3.175-2.137T2.788 15.9T2 12t.788-3.9t2.137-3.175T8.1 2.788T12 2t3.9.788t3.175 2.137T21.213 8.1T22 12t-.788 3.9t-2.137 3.175t-3.175 2.138T12 22m0-2q3.35 0 5.675-2.325T20 12t-2.325-5.675T12 4T6.325 6.325T4 12t2.325 5.675T12 20m0-8"/>
            </svg>
            <span id="bulk-tooltip" 
              style="display: none; position: absolute; bottom: 125%; left: 50%; transform: translateX(-50%);
                background-color: #333; color: #fff; padding: 5px 10px; border-radius: 4px;
                white-space: nowrap; font-size: 12px; z-index: 999; max-width:32em; max-height:20em;">
              ${i18n.t('backoffice.bulkSend.text')}
            </span>
          </a>
        </div>
        <br>
        <input id="swal-input3" class="swal2-input" type="text" value="${toPhone}" placeholder="${i18n.t('backoffice.titles.phonePlaceholder')}"><br><label style="color:rgb(225, 45, 45);font-size:13px; text-align: left;">Example: +19738779221</label><br>
        <label><input type="checkbox" id="email-checkbox" checked>${i18n.t('backoffice.titles.sendEmail')} |</label>
        <label><input type="checkbox" id="sms-checkbox" checked>${i18n.t('backoffice.titles.sendSMS')}</label><br>
        <label for="swal-input1">${i18n.t('backoffice.titles.whenToSend')}</label>
        <input id="swal-input1" class="swal2-input" type="datetime-local" value="${dateTimeString}">
        <div style="display: flex; justify-content: center; gap: 10px; margin-top: 20px;">
          <button id="add-subscriber-btn" class="swal2-input" style="display: none; background:#00A550; border-radius:4px; color: white; font-weigth:bold;">${i18n.t('backoffice.titles.createSubscriptor')}</button>
          <button id="add-customer-btn" class="swal2-input" style="display: none; background:#00A550; border-radius:4px; color: white; font-weigth:bold;">${i18n.t('backoffice.titles.createCustomer')}</button>
        </div>
        `,
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: i18n.t('backoffice.titles.sendNow'),
      denyButtonText: i18n.t('backoffice.titles.schedule'),
      cancelButtonText: i18n.t('backoffice.titles.cancel'),
      focusConfirm: false,
      didOpen: () => {
        document.getElementById('bulk-send').addEventListener('click', () =>   NotificationUtil.bulkSendEmail(toEmail, toPhone, scheduledAt, cb, emailLabel = null, showButtons));
        //document.getElementById('bulk-info').addEventListener('click', () =>   NotificationUtil.bulkInfo(toEmail, toPhone, scheduledAt, cb, emailLabel = null,showButtons));
        const bulkInfo = document.getElementById('bulk-info');
        const tooltip = document.getElementById('bulk-tooltip');

        bulkInfo.addEventListener('mouseenter', () => {
          tooltip.style.display = 'block';
        });

        bulkInfo.addEventListener('mouseleave', () => {
          tooltip.style.display = 'none';
        });

        const showSearchBtn = document.getElementById('show-search-btn');
        const searchContainer = document.getElementById('search-container');
        const customerSearchInput = document.getElementById('customer-search');
        const customerList = document.getElementById('customer-list');
        const emailInput = document.getElementById("swal-input2");
        const addSubscriberBtn = document.getElementById("add-subscriber-btn");
        const addCustomerBtn = document.getElementById("add-customer-btn");
        if (showButtons) {
          emailInput.addEventListener('input', () => {
            const emailStr = emailInput.value;
            if (!NotificationUtil.isEmail(emailStr)) {
              // Si no es un correo válido, oculta ambos botones
              addSubscriberBtn.style.display = 'none';
              addCustomerBtn.style.display = 'none';
              return; // Salir de la función
          }
            const emailExists = NotificationUtil.emailExists(emailStr);
            const emailCustomerExists = NotificationUtil.emailCustomerExist(emailStr);
        
            if (emailStr && !emailExists && !emailCustomerExists) {
                addSubscriberBtn.style.display = 'block';
                addCustomerBtn.style.display = 'block';
            } else if (emailStr && !emailExists) {
                addSubscriberBtn.style.display = 'none';
                addCustomerBtn.style.display = 'block';
            } else if (emailStr && !emailCustomerExists) {
                addSubscriberBtn.style.display = 'block';
                addCustomerBtn.style.display = 'none';
            } else {
                addSubscriberBtn.style.display = 'none';
                addCustomerBtn.style.display = 'none';
            }
          });

          addSubscriberBtn.addEventListener('click', () => {
            const emailStr = document.getElementById("swal-input2").value; 
            const phoneStr = document.getElementById("swal-input3").value;

            const event = new CustomEvent('email-not-found', { detail: { recivedEmail: emailStr, recivedPhone: phoneStr } });
            window.dispatchEvent(event);
            Swal.close();
          });

          addCustomerBtn.addEventListener('click', () => {
            const emailStr = document.getElementById("swal-input2").value; 
            const phoneStr = document.getElementById("swal-input3").value;

            const event = new CustomEvent('open-customer-modal', { detail: { recivedEmail: emailStr, recivedPhone: phoneStr } });
            window.dispatchEvent(event);
            Swal.close();
          });
        }
        if (showSearchBtn && searchContainer) {
            showSearchBtn.addEventListener('click', () => {
                searchContainer.style.display = 'block';
                showSearchBtn.style.display = 'none';
            });
        }
    
        if (customerSearchInput && customerList) {
          customerSearchInput.addEventListener('input', () => {
              const searchTerm = customerSearchInput.value.toLowerCase();
              customerList.innerHTML = '';
      
              if (searchTerm.length > 0) {
                  const filteredCustomers = store.state.backConfig.allCustomer.filter(
                      customer => (
                          (customer.Name && customer.Name.toLowerCase().includes(searchTerm)) ||
                          (customer.Email && customer.Email.toLowerCase().includes(searchTerm)) ||
                          (customer.EmailAddress && customer.EmailAddress.toLowerCase().includes(searchTerm)) ||
                          (customer.Phone && customer.Phone.toLowerCase().includes(searchTerm))
                      )
                  );
      
                  const filteredSubscribers = store.state.backConfig.subscriber.filter(
                      subscriber => (
                          (subscriber.Name && subscriber.Name.toLowerCase().includes(searchTerm)) ||
                          (subscriber.Email && subscriber.Email.toLowerCase().includes(searchTerm)) ||
                          (subscriber.EmailAddress && subscriber.EmailAddress.toLowerCase().includes(searchTerm)) ||
                          (subscriber.Phone && subscriber.Phone.toLowerCase().includes(searchTerm))
                      )
                  );
      
                  const combinedList = [...filteredCustomers, ...filteredSubscribers];
      
                  combinedList.forEach(item => {
                      const listItem = document.createElement('ion-item');
                      listItem.textContent = `${item.Name} (${item.Email || item.EmailAddress}) ${item.Phone || ''}`;
                      listItem.addEventListener('click', () => {
                          document.getElementById('swal-input2').value = item.Email || item.EmailAddress;
                          document.getElementById('swal-input3').value = item.Phone;
                          customerList.innerHTML = '';
                      });
                      customerList.appendChild(listItem);
                  });
              }
          });
      }
    },
      preConfirm: () => {
        const emailStr = document.getElementById("swal-input2").value;
        const phoneStr = document.getElementById("swal-input3").value;
        const sendEmail = document.getElementById("email-checkbox").checked;
        const sendSms = document.getElementById("sms-checkbox").checked;

        if (!sendEmail && !sendSms) {
          return Swal.showValidationMessage("Please select at least one method (Email or SMS)");
        }

        let method = [];
        if (sendEmail) method.push('email');
        if (sendSms) method.push('phone');
        
        let emails = [];
        if (emailStr) emails.push(emailStr);
        return {
          email: emailStr,
          mobile: phoneStr,
          method: method.join(','),
        };
      },
      preDeny: () => {
        const emailStr = document.getElementById("swal-input2").value;
        const phoneStr = document.getElementById("swal-input3").value;
        const scheduleVal = document.getElementById("swal-input1").value;
        const sendEmail = document.getElementById("email-checkbox").checked;
        const sendSms = document.getElementById("sms-checkbox").checked;

        if (!sendEmail && !sendSms) {
          return Swal.showValidationMessage("Please select at least one method (Email or SMS)");
        }

        if (!scheduleVal || new Date() > new Date(scheduleVal)) {
          return Swal.showValidationMessage("The scheduled date and time must be in the future.");
        }

        let method = [];
        if (sendEmail) method.push('email');
        if (sendSms) method.push('phone');

        return {
          schedule: new Date(scheduleVal).getTime(),
          email: emailStr,
          mobile: phoneStr,
          method: method.join(','),
        };
      },
    });

    // Handle actions based on the button selected
    if (result.isConfirmed) {
      console.log(result.value.email);
      
      // Send Now
      cb(false, { email: result.value.email, mobile: result.value.mobile, method: result.value.method, scheduledAt: null });
    } else if (result.isDenied) {
      // Schedule
      const value = result.value;
      cb(false, { email: value.email, mobile: value.mobile, method: value.method, scheduledAt: value.schedule });
    } else {
      // Cancel
      cb(true, null);
    }
  },
};
